"use client";
import styles from "./Drawer.module.css";
import { BaseSyntheticEvent, useEffect, useRef, useState } from "react";
import { ISideDrawerComponentProps } from "../../../types/components";
import CustomLinkComponent from "../Link/Link";
import CustomImageComponent from "../Image/Image";
import { multipleClassName } from "../../../utils/helpers";
import { useDownloadContext } from "../../../contexts/CommonContext";
import Image from "next/image";

const SideDrawerComponent = (props: ISideDrawerComponentProps) => {
  const { navigationDataLinks, navigationDataLinksV2, navData } = props;
  const { handleHamburgerClick, menuOpen } = useDownloadContext();
  const [isDropDownOpen, setIsDropDownOpen] = useState<any>({});

  const handleSideBarClose = () => {
    setIsDropDownOpen({});
    handleHamburgerClick();
  };

  return navData ? (
    <>
      <aside
        className={styles.drawer}
        style={menuOpen ? { width: "100%" } : { width: 0 }}
      >
        <div>
          <nav
            className={styles.navbar}
            style={
              menuOpen
                ? {
                    transition: "opacity 0.5s ease-in",
                    opacity: 0.99,
                  }
                : { opacity: 0 }
            }
          >
            <div
              className={multipleClassName(
                "container-fluid",
                styles.menuContainer
              )}
            >
              {navData.map((data: any, index: number) => {
                return (
                  <div key={"gameRow" + index}>
                    <div className={multipleClassName("row", styles.gameRow)}>
                      {data.url ? (
                        <div
                          className={multipleClassName(
                            "col",
                            styles.headingLinkContainer
                          )}
                          onClick={() => handleSideBarClose()}
                        >
                          <CustomLinkComponent
                            className={styles.navItemClickable}
                            href={data.url}
                            mobStyle={{
                              textDecoration: "none",
                            }}
                            desktopStyle={{
                              textDecoration: "none",
                            }}
                          >
                            {data.heading}
                          </CustomLinkComponent>
                        </div>
                      ) : (
                        <div
                          id={"dropDown"}
                          className={multipleClassName("col", styles.navItem)}
                          key={"navItem" + index}
                          onClick={() => {
                            setIsDropDownOpen((prev: any) => {
                              return {
                                ...prev,
                                [`navItem${index}`]: !prev[`navItem${index}`],
                              };
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div> {data.heading}</div>
                          <div
                            className={styles.dropDownArrow}
                            style={
                              isDropDownOpen[`navItem${index}`]
                                ? {
                                    transition: "all 0.5s ease-in",
                                    transform: "rotate(180deg)",
                                  }
                                : {
                                    transform: "rotate(0deg)",
                                    transition: "all 0.5s ease-in",
                                  }
                            }
                          >
                            <Image
                              src={
                                "https://d3g4wmezrjkwkg.cloudfront.net/zo-business/staging/Images/dropdownArrow.webp"
                              }
                              alt="Dropdown arrow"
                              fill
                              objectFit="contain"
                              sizes="(max-width: 576px) 5vw, (max-width: 1200px) 2.5vw, 2vw"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {data.navLinks.length > 0 && (
                      <div
                        className={styles.subLinksContainer}
                        style={
                          isDropDownOpen[`navItem${index}`]
                            ? {
                                transition: "all 0.5s ease-in",
                                maxHeight: "200px",
                                opacity: 0.99,
                              }
                            : {
                                opacity: 0,
                                maxHeight: 0,
                                transition: "all 0.5s ease-in",
                              }
                        }
                        onClick={() => handleSideBarClose()}
                      >
                        {data.navLinks.map((item: any, i: number) => {
                          return item.outside ? (
                            <a
                              href={item.link}
                              className={styles.clickOutside}
                              key={"clickOutside_" + i}
                            >
                              {item.title}
                            </a>
                          ) : (
                            <span
                              key={"clickOutside_" + i}
                              className={styles.clickInside}
                            >
                              <CustomLinkComponent
                                href={item.link}
                                key={i}
                                mobStyle={{
                                  color: "#d8d8d8",
                                }}
                                desktopStyle={{
                                  color: "#d8d8d8",
                                }}
                              >
                                {item.title}
                              </CustomLinkComponent>
                            </span>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </nav>
        </div>
      </aside>
    </>
  ) : (
    <></>
  );
};

export default SideDrawerComponent;
